import { render, staticRenderFns } from "./ImgLoader.vue?vue&type=template&id=185f39fa&scoped=true"
import script from "./ImgLoader.vue?vue&type=script&lang=js"
export * from "./ImgLoader.vue?vue&type=script&lang=js"
import style0 from "./ImgLoader.vue?vue&type=style&index=0&id=185f39fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185f39fa",
  null
  
)

export default component.exports